import PageSEO from '@/components/base/PageSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '国产一区精选内容聚合平台',
  url: 'https://guochan1qu.com',
  description:
    '国产一区汇聚海量优质国产原创内容，精心分类整理，为用户提供流畅、清晰、丰富的一站式浏览体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://guochan1qu.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '国产一区精选内容聚合平台',
  url: 'https://guochan1qu.com',
  description:
    '国产一区精选内容聚合平台，致力于为用户提供最全面、最优质的国产原创内容聚合服务。',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '国产一区平台主要提供什么类型的内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '国产一区精选内容聚合平台汇聚了影视综娱、科技数码、生活百科、文学艺术、音乐天地、游戏动漫等八大分类的优质国产原创内容。',
      },
    },
    {
      '@type': 'Question',
      name: '平台上的内容是免费浏览的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，国产一区平台上的所有内容均为免费浏览，无需注册，无需付费。',
      },
    },
    {
      '@type': 'Question',
      name: '内容多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '编辑团队每日都会更新平台内容，确保您能够第一时间获取到最新的国产原创精选。',
      },
    },
    {
      '@type': 'Question',
      name: '如何快速找到我感兴趣的内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过首页的分类导航快速定位感兴趣的内容领域，也可以使用页面顶部的导航栏在不同分类之间自由切换。',
      },
    },
    {
      '@type': 'Question',
      name: '平台的国产原创内容来源是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '国产一区平台的内容来自国内优秀的原创作者和媒体机构，所有收录的内容都经过编辑团队的审核和筛选。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系平台或提供内容合作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过"关于我们"页面中的联系方式与我们取得联系，期待与您共同打造更丰富的国产原创内容生态。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="国产一区精选内容聚合平台 - 汇聚海量优质国产原创内容，一站式浏览体验"
        description="国产一区汇聚海量优质国产原创内容，精心分类整理，为用户提供流畅、清晰、丰富的一站式浏览体验。无论您寻找热门资源还是冷门珍藏，国产一区都能满足您的需求，立即探索最全国产内容库。"
        keywords="国产一区,国产一区精选,国产一区最新资源,国产一区高清合集,国产一区免费浏览,国产原创内容聚合"
        canonicalUrl="https://guochan1qu.com"
        schemaData={[websiteSchema, orgSchema, faqSchema]}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}